import React from "react";

import {
  Box,
  Stack,
  Typography,
} from "@mui/material";

const PRESENTATION = {
  CHECKING: {
    label: "Checking connection",
    activeBars: 1,
    color: "text.disabled",
  },

  GOOD: {
    label: "Good connection",
    activeBars: 3,
    color: "success.main",
  },

  FAIR: {
    label: "Fair connection",
    activeBars: 2,
    color: "warning.main",
  },

  POOR: {
    label: "Poor connection",
    activeBars: 1,
    color: "error.main",
  },
};

const ConnectionQualityIndicator = ({
  status = "CHECKING",
}) => {
  const presentation =
    PRESENTATION[status] ||
    PRESENTATION.CHECKING;

  const barHeights = [
    6,
    10,
    14,
  ];

  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      aria-label={
        presentation.label
      }
    >
      <Box
        sx={{
          height: 16,
          display: "flex",
          alignItems: "flex-end",
          gap: "2px",
        }}
      >
        {barHeights.map(
          (
            height,
            index,
          ) => {
            const active =
              index <
              presentation.activeBars;

            return (
              <Box
                key={height}
                sx={{
                  width: 3,
                  height,
                  borderRadius:
                    "2px",
                  bgcolor: active
                    ? presentation.color
                    : "grey.300",
                }}
              />
            );
          },
        )}
      </Box>

      <Typography
        variant="caption"
        sx={{
          color:
            presentation.color,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        {presentation.label}
      </Typography>
    </Stack>
  );
};

export default ConnectionQualityIndicator;